import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagifyComponent } from './tagify.component';

@NgModule({
  declarations: [TagifyComponent],
  imports: [CommonModule],
  exports: [TagifyComponent],
})
export class TagifyModule {}
